import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link } from "react-router-dom";

export default function RedemarrerQuestionnaire(){
  return (
    <div style={{display: "grid", justifyItems: "center", marginTop: "9rem"}}>
            <Typography component="h1" variant="h2" align="center" color="text.primary" gutterBottom marginTop="2rem"> Veuillez commencer le </Typography>
            <Typography component="h1" variant="h2" align="center" color="text.primary" gutterBottom marginTop="2rem"> questionnaire au debut </Typography>
            <Link style={{textDecoration: 'none'}} to="/questionnaire">
                <Button variant="contained" sx={{backgroundColor: "#307B5B", "&:hover": {backgroundColor: "#8EBF55", color: "black", fontWeight: "bold"}}} style={{width: "15rem", height: "4rem"}}>Aller au questionnaire</Button>
            </Link>
    </div>
  );
}